<script setup lang="ts">
    import { inject } from 'vue';
    import AppMenuAccountChangeLocaleAndTimeZone from './AppMenuAccountChangeLocaleAndTimeZone.vue';
    import AppMenuAccountChangeSettings from './AppMenuAccountChangeSettings.vue';
    import { useMenuStore } from '@/stores/menu';
    import { useUserStore } from '@/stores/user';
    import { useDisplay, useTheme } from 'vuetify';

    const userStore = useUserStore();
    const menuStore = useMenuStore();
    const display = useDisplay();
    const theme = useTheme();

    const { t } = useI18n();

    const changeOrderSettingsDialogRef = inject<any>('changeOrderSettingsDialogRef');

    const showChangeOrderSettingsDialog = (): void => {
        if (changeOrderSettingsDialogRef) {
            changeOrderSettingsDialogRef.value.open();
        }
    };
</script>
<template>
    <v-menu v-model="menuStore.userMenu" :close-on-content-click="false" :nudge-width="200" offset="1px 175px">
        <template v-slot:activator="{ props }">
            <v-btn tag="a" class="link-menu" :height="display.xs.value ? 30 : 46" min-width="30" :width="display.xs.value ? 30 : 50" variant="text" v-bind="props" :data-tooltip="t('menu.account')">
                <v-icon size="24" :color="theme.name.value === 'dark' ? '' : '#867878'" :icon="mdiAccountBoxOutline" />
            </v-btn>
        </template>

        <v-card v-if="userStore.login" width="350px" variant="outlined">
            <AppMenuAccountChangeSettings></AppMenuAccountChangeSettings>

            <v-card-text class="py-2">
                <v-container class="font14 pl-4 pr-0 py-0">
                    <v-row>
                        <v-col cols="12" class="py-2 pl-1">
                            <span @click="showChangeOrderSettingsDialog" class="cursorPointer lightGreyText">
                                <v-icon style="margin-bottom: 2px" :icon="mdiCogOutline" />
                                {{ t('menu.orderSettings') }}
                            </span>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <AppMenuAccountChangeLocaleAndTimeZone></AppMenuAccountChangeLocaleAndTimeZone>
        </v-card>
    </v-menu>
</template>
<style scoped>
    .v-theme--light.v-card--variant-outlined {
        border: thin solid rgba(0, 0, 0, 0.12);
    }

    .v-theme--dark.v-card--variant-outlined {
        background-color: #1e1f22 !important;
        border: 1px solid #404148 !important;
    }
</style>
